import { ref, computed, onMounted } from 'vue';
// TODO: criar entity
import { useFetchUsers } from '@/entities/User';

export interface TestContentFilter {
  elaboratedBy?: string;
  approvedBy?: string;
  requestDate?: Date | null;
}

export function useTestContentFilter(
  emit: (event: 'update:filter', filters: TestContentFilter) => void
) {
  const formData = ref({
    elaboratedBy: '',
    approvedBy: '',
    requestDate: null as Date | null,
  });

  const { fetchAllUsers, users } = useFetchUsers();
  onMounted(fetchAllUsers);
  const usersList = computed(() => users.value?.data || []);

  const clearFilters = () => {
    formData.value = {
      elaboratedBy: '',
      approvedBy: '',
      requestDate: null,
    };
    emit('update:filter', {});
  };

  const applyFilters = () => {
    const cleanFilters: TestContentFilter = {};
    if (formData.value.elaboratedBy) {
      cleanFilters.elaboratedBy = formData.value.elaboratedBy;
    }
    if (formData.value.approvedBy) {
      cleanFilters.approvedBy = formData.value.approvedBy;
    }
    if (formData.value.requestDate) {
      cleanFilters.requestDate = formData.value.requestDate;
    }

    emit('update:filter', cleanFilters);
  };

  return {
    formData,
    usersList,
    clearFilters,
    applyFilters,
  };
}
